import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Briefcase, Stethoscope, Building2, ChevronRight, Scale, HardHat, PiggyBank } from "lucide-react";

const SECTIONS = [
  {
    title: "Professioni Sanitarie",
    desc: "RC Professionale adeguata al Decreto Gelli per medici, odontoiatri, personale sanitario e strutture.",
    icon: Stethoscope,
    link: "/questionario/professionisanitarie",
  },
  {
    title: "Professioni Economiche e Giuridiche",
    desc: "Avvocati, Commercialisti, Consulenti del Lavoro, DPO, Mediatori e Centri EDP/CAF/CAAF.",
    icon: Scale,
    link: "/questionario/economico-giuridico",
  },
  {
    title: "Professioni Tecniche",
    desc: "Architetti, Ingegneri, Geologi, Geometri, Chimici, Agronomi, Tecnologi Alimentari, Certificatori e Asseverazione.",
    icon: HardHat,
    link: "/questionario/area-tecnica",
  },
  {
    title: "RC Professionale Generica",
    desc: "Copertura per aziende, liberi professionisti e altre attività non incluse nelle categorie specifiche.",
    icon: Building2,
    link: "/consulenza?prodotto=rc_professionale_generica",
    comingSoon: true,
  },
  {
    title: "Fondi Pensione — PIP Reale Mutua",
    desc: "Pensione integrativa per liberi professionisti senza Cassa o con Cassa minima. Deduzione fiscale fino a 5.164,57 €/anno.",
    icon: PiggyBank,
    link: "/fondi-pensione",
  },
];

export default function ProfessioniPage() {
  return (
    <>
      <Header />
      <main className="min-h-screen bg-[#FCFCFA] pt-20" data-testid="professioni-page">
        <div className="max-w-3xl mx-auto px-5 sm:px-6 py-12">
          <div className="text-center mb-10">
            <div className="w-14 h-14 mx-auto mb-4 bg-[#163321]/10 rounded-full flex items-center justify-center">
              <Briefcase className="w-7 h-7 text-[#163321]" />
            </div>
            <h1 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-medium tracking-tight text-[#0F1F14] mb-3" data-testid="professioni-title">
              Polizze per Professionisti
            </h1>
            <p className="text-sm text-[#4A5E51] max-w-lg mx-auto">
              Scegli la tua area professionale per accedere al questionario dedicato e ricevere una proposta su misura.
            </p>
          </div>

          <div className="space-y-4">
            {SECTIONS.map((s, i) => (
              <Link
                key={i}
                to={s.link}
                className="block bg-white rounded-2xl border border-[#E5E2DB] p-6 premium-card hover:border-[#163321]/30 transition-all group"
                data-testid={`prof-section-${i}`}
              >
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-xl bg-[#163321]/5 group-hover:bg-[#163321]/10 flex items-center justify-center transition-colors shrink-0">
                    <s.icon className="w-6 h-6 text-[#163321]" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="font-heading text-base sm:text-lg font-medium text-[#0F1F14] group-hover:text-[#163321] transition-colors mb-1 flex items-center gap-2 flex-wrap">
                      {s.title}
                      {s.comingSoon && (
                        <span className="text-[10px] uppercase tracking-widest font-bold px-2 py-0.5 rounded bg-[#163321] text-[#D9C49A]" data-testid={`prof-coming-soon-${i}`}>
                          Su richiesta
                        </span>
                      )}
                    </h3>
                    <p className="text-sm text-[#4A5E51] leading-relaxed">{s.desc}</p>
                  </div>
                  <ChevronRight className="w-5 h-5 text-[#4A5E51] group-hover:text-[#163321] group-hover:translate-x-1 transition-all shrink-0 mt-1" />
                </div>
              </Link>
            ))}
          </div>

          <div className="mt-10 text-center">
            <p className="text-xs text-[#4A5E51] italic">
              "Parlerai con un consulente reale, non con un sistema automatico"
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
